import { jsx as o } from "react/jsx-runtime";
import r from "./style.module.less.js";
const i = (s) => {
  const { className: e } = s;
  return /* @__PURE__ */ o("svg", { className: `${r.loadingIcon} ${e ?? ""}`, viewBox: "0 0 50 50", fill: "none", children: /* @__PURE__ */ o("circle", { className: "path", cx: "25", cy: "25", r: "20", strokeWidth: "5" }) });
};
export {
  i as LoadingSpinner
};
